import moment from "moment";
import "moment/locale/es";
import { cuentaMask, dineroDisabledMask } from '../Components/Items'

moment.locale("es");

const reportedeCuentasPorCobrarArupado = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    const quitarLimiteCredito = values.quitarLimiteCredito;
    const quitarDiasCredito = values.quitarDiasCredito;
    let filtrados = []

    if (values.fechaVencimiento) {
        filtrados.push([
            { text: 'Fecha de Corte:', style: 'subheader' },
            { text: moment(values.fechaVencimiento).format('DD/MM/YYYY'), style: 'textoChico' }
        ]);
    }

    // Gemelo de etiquetaFiltroVentaOnline (erp_backend/Utils/filtroVentaOnline.utils.js)
    const tipoDeVenta = values.filtroVentaOnline === 'ecommerce' ? 'Ecommerce' : values.filtroVentaOnline === 'normales' ? 'Normales' : null;
    if (tipoDeVenta) {
        filtrados.push([
            { text: 'Tipo de venta:', style: 'subheader' },
            { text: tipoDeVenta, style: 'textoChico' }
        ]);
    }
    if (values.clientes !== 0 && values.clientes && values.clientes.length > 0) {
        let textoFiltrado = ''
        values.clientes.map((valueCliente) => {
            textoFiltrado += `${(valueCliente.persona ? valueCliente.nombre : (valueCliente.nombre + ' ' + valueCliente.apellidoPaterno + ' ' + valueCliente.apellidoMaterno)) + valueCliente.razonSocial + " - " + valueCliente.rfc}\n`
            return null
        })
        filtrados.push([
            { text: 'Clientes:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.vendedores !== 0 && values.vendedores && values.vendedores.length > 0) {
        let textoFiltrado = ''
        values.vendedores.map((valueVendedores) => {
            textoFiltrado += `${valueVendedores.nombre +
                " " +
                valueVendedores.apellidoPaterno +
                " " +
                valueVendedores.apellidoMaterno}\n`
            return null
        })
        filtrados.push([
            { text: 'Vendedores:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.filtrarProyecto === 1) {
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            { text: 'Proyectos:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.filtrarProyecto === 2) {
        filtrados.push([
            { text: 'Unidad de Negocio:', style: 'subheader' },

            {
                text: `${cuentaMask(
                    values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 + values.unidadDeNegocio.nivel5
                ) +
                    " - " +
                    values.unidadDeNegocio.nombre}`, style: 'textoChico'
            }
        ])
    }

    let grupos = [];
    let grupoActual = [];

    for (const venta of values.ventas) {
        // Usamos la bandera directa del backend 'insumo'
        const esHijo = venta.insumo === true;

        if (!esHijo) {
            // Es Padre (Factura nueva)
            if (grupoActual.length > 0) {
                grupos.push(grupoActual);
            }
            grupoActual = [venta];
        } else {
            // Es Hijo (Insumo), lo pegamos al grupo actual
            grupoActual.push(venta);
        }
    }
    if (grupoActual.length > 0) {
        grupos.push(grupoActual);
    }

    // Ordenar los grupos por la fecha del padre
    grupos.sort((a, b) => {
        const fechaA = moment(a[0].fechaFactura, "DD/MM/YYYY").toDate();
        const fechaB = moment(b[0].fechaFactura, "DD/MM/YYYY").toDate();
        return fechaA - fechaB;
    });


    const datosAgrupados = {};

    grupos.forEach(grupo => {
        const cabeza = grupo[0]; 
        const clienteId = cabeza.clienteId || 'SinCliente';
        const monedaKey = cabeza.moneda || 'Sin Moneda';

        if (!datosAgrupados[clienteId]) {
            datosAgrupados[clienteId] = {
                infoCliente: cabeza, 
                monedas: {}
            };
        }

        if (!datosAgrupados[clienteId].monedas[monedaKey]) {
            datosAgrupados[clienteId].monedas[monedaKey] = [];
        }

        datosAgrupados[clienteId].monedas[monedaKey].push(...grupo);
    });
   
    const tablasDinamicas = [];

    let granTotalTotales = 0;
    let granTotalAbonos = 0;
    let granTotalSaldo = 0;
    let granTotalVencido = 0;
    let granTotalNoVencido = 0;

    // Recorremos cada Cliente
    Object.keys(datosAgrupados).forEach((clientId, index) => {
        const clienteData = datosAgrupados[clientId];
        const info = clienteData.infoCliente;

        // Cabecera Azul del Cliente
        tablasDinamicas.push({
            style: 'tableExample',
            pageBreak: (values.saltoPaginaPorCliente && index > 0) ? 'before' : undefined,
            table: {
                widths: ['100%'],
                body: [
                    [
                        { 
                            text: info.cliente + 
                            (quitarDiasCredito ? '' : ' - Dias Credito: ' + (info.diasCredito ? info.diasCredito : 0)) + 
                            (quitarLimiteCredito ? '' : ' - Limite Credito: ' + dineroDisabledMask(info.limiteCredito ? info.limiteCredito : 0)), 
                            style: 'clienteTabla', 
                            alignment: 'center' 
                        }
                    ]
                ]
            },
        });

        // Recorremos cada Moneda de este Cliente
        Object.keys(clienteData.monedas).forEach(monedaNombre => {
            const ventasDeLaMoneda = clienteData.monedas[monedaNombre];
            
            let filasTabla = [];
            let totalTotales = 0;
            let totalAbonos = 0;
            let totalSaldo = 0;
            let totalVencido = 0;
            let totalNoVencido = 0;

            // Generar filas
            ventasDeLaMoneda.forEach(valueVenta => {
                const properties = valueVenta.colorStyle ? { background: valueVenta.colorStyle } : {};
                
                if (!valueVenta.insumo) {
                    totalTotales += valueVenta.totalPagar || 0;
                    totalAbonos += valueVenta.totalPagado || 0;
                    totalSaldo += valueVenta.saldo || 0;

                    let diasVencido = 0;
                    const fechaVencimientoValida = typeof valueVenta.fechaVencimiento === 'string' && moment(valueVenta.fechaVencimiento, "DD/MM/YYYY", true).isValid();
                    if (fechaVencimientoValida) {
                        if (moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").isBefore(moment())) {
                            diasVencido = moment().diff(moment(valueVenta.fechaVencimiento, "DD/MM/YYYY"), 'days');
                            totalVencido += valueVenta.saldo || 0;
                        } else {
                            totalNoVencido += valueVenta.saldo || 0;
                        }
                    }

                    filasTabla.push([
                        { text: valueVenta.folio, style: 'textoTabla', alignment: 'left' },
                        { text: isNaN(valueVenta.fechaFactura) ? moment(valueVenta.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' },
                        { text: fechaVencimientoValida ? moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L') : (valueVenta.fechaVencimiento || ''), style: 'textoTabla', alignment: 'center' },
                        { text: diasVencido, style: 'textoTabla', alignment: 'center' },
                        { text: valueVenta.estado, ...properties, style: 'textoTabla', alignment: 'left' },
                        { text: valueVenta.vendedor, style: 'textoTabla', alignment: 'left' },
                        { text: dineroDisabledMask(valueVenta.totalPagar), style: 'textoTabla', alignment: 'right' },
                        { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' },
                        { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
                    ]);
                } 
                else {
                    
                    filasTabla.push([
                        { text: '', style: 'textoTabla' },
                        { text: valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' }, // Cantidad
                        { text: valueVenta.cliente, style: 'textoTabla', alignment: 'left', colSpan: 2 }, // Descripción
                        {},
                        { text: '', style: 'textoTabla' }, 
                        { text: dineroDisabledMask(valueVenta.totalPagar), style: 'textoTabla', alignment: 'right' }, // Precio Unitario
                        { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' },
                        { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
                        { text: dineroDisabledMask(valueVenta.estado), style: 'textoTabla', alignment: 'right' }, // Total Línea
                    ]);
                }
            });

            granTotalTotales += totalTotales;
            granTotalAbonos += totalAbonos;
            granTotalSaldo += totalSaldo;
            granTotalVencido += totalVencido;
            granTotalNoVencido += totalNoVencido;

            if (totalTotales > 0 || totalAbonos > 0 || totalSaldo > 0) {
                filasTabla.push([
                    { text: 'Totales (' + monedaNombre + '):', style: 'totalesTabla', alignment: 'left', colSpan: 6 },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(totalTotales), style: 'totalesTabla', alignment: 'right' },
                    { text: dineroDisabledMask(totalAbonos), style: 'totalesTabla', alignment: 'right' },
                    { text: dineroDisabledMask(totalSaldo), style: 'totalesTabla', alignment: 'right' },
                ], [
                    { text: 'Vencido (' + monedaNombre + '):', style: 'totalesTabla', alignment: 'left', colSpan: 6 },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(totalVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
                    {}, {}
                ], [
                    { text: 'No Vencido (' + monedaNombre + '):', style: 'totalesTabla', alignment: 'left', colSpan: 6 },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(totalNoVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
                    {}, {}
                ]);
            }

            // Agregar la tabla de esta moneda
            tablasDinamicas.push(
                { text: `Moneda: ${monedaNombre}`, style: 'subheader', margin: [0, 5, 0, 2] },
                {
                    style: 'tableExample',
                    table: {
                        widths: ['10%', '10%', '10%', '8%', '12%', '14%', '12%', '12%', '12%'],
                        headerRows: 1,
                        layout: { defaultBorder: true },
                        body: [
                            [
                                { text: 'Folio', style: 'tituloTabla' },
                                { text: 'Fecha', style: 'tituloTabla' },
                                { text: 'Vencimiento', style: 'tituloTabla' },
                                { text: 'D. Venc', style: 'tituloTabla' },
                                { text: 'Estado', style: 'tituloTabla' },
                                { text: 'Vendedor', style: 'tituloTabla' },
                                { text: 'Total', style: 'tituloTabla' },
                                { text: 'Abonos', style: 'tituloTabla' },
                                { text: 'Saldo', style: 'tituloTabla' },
                            ],
                            ...filasTabla
                        ]
                    },
                    layout: {
                        fillColor: (rowIndex, node, columnIndex) => { return rowIndex % 2 === 0 ? "#f3f3f3" : "#ffffff"; },
                        hLineWidth: function (i, node) { return (i === 0 || i === node.table.body.length) ? 1 : 1; },
                        vLineWidth: function (i, node) { return (i === 0 || i === node.table.widths.length) ? 1 : 1; },
                        hLineColor: function (i, node) { return '#adaaaa'; },
                        vLineColor: function (i, node) { return '#adaaaa'; },
                        hLineStyle: function (i, node) { if (i === 0 || i === node.table.body.length) return null; return { dash: { length: 2, space: 1 } }; },
                        vLineStyle: function (i, node) { if (i === 0 || i === node.table.widths.length) return null; return { dash: { length: 2 } }; }
                    }
                },
                // Espacio entre monedas
                { text: '', margin: [0, 0, 0, 10] }
            );
        });
    });


    tablasDinamicas.push({
        style: 'tableExample',
        table: {
            widths: ['10%', '10%', '10%', '8%', '12%', '14%', '12%', '12%', '12%'],
            body: [
                [
                    { text: 'GRAN TOTAL:', style: 'totalesTabla', alignment: 'left', colSpan: 6, fillColor: '#aaaaaa' },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(granTotalTotales), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                    { text: dineroDisabledMask(granTotalAbonos), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                    { text: dineroDisabledMask(granTotalSaldo), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                ],
                [
                    { text: 'GRAN TOTAL VENCIDO:', style: 'totalesTabla', alignment: 'left', colSpan: 6, fillColor: '#aaaaaa' },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(granTotalVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3, fillColor: '#aaaaaa' },
                    {}, {}
                ],
                [
                    { text: 'GRAN TOTAL NO VENCIDO:', style: 'totalesTabla', alignment: 'left', colSpan: 6, fillColor: '#aaaaaa' },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(granTotalNoVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3, fillColor: '#aaaaaa' },
                    {}, {}
                ],
            ]
        },
        layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => '#aaaaaa', vLineColor: () => '#aaaaaa' }
    });

    if (filtrados.length === 0) {
        filtrados.push([
            { text: 'No tiene filtrados adicionales', style: 'subheader' },

            { text: '', style: 'textoChico' }
        ])
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                //							rowSpan: 3,
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80]
                                //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                            },
                            {
                                //	rowSpan: 2,
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [
                                            {
                                                text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno),
                                                style: "tableHeader"
                                            }
                                        ],
                                        [
                                            {
                                                text: "R.F.C: " + empresa.rfc,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.calle + ' ' +
                                                    empresa.numeroCalle + ' ' +
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.colonia.tipoAsentamiento + ' ' +
                                                    empresa.colonia.nombre + ' C.P. ' +
                                                    empresa.colonia.cp + ' ' +
                                                    empresa.municipio.nombre + ' ' +
                                                    empresa.estado.abreviatura + ' ' +
                                                    empresa.pais.abreviatura + ' '
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [{ text: 'REPORTE DE CUENTAS POR COBRAR', style: 'tableHeader' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                        [{ text: 'Desglose:', style: 'subheader', alignment: 'center' }],
                                        [{ text: values.detalle ? 'Si' : 'No', style: 'textoChico', alignment: 'center' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]

                    ]
                },
            },
            { text: 'Datos de filtrado:' },
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                        defaultBorder: false,
                    },

                    body: filtrados,
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }

            },
           ...tablasDinamicas,
        ],
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico: {
                fontSize: 8
            },
            tituloTabla: {
                fontSize: 8,
                bold: true,
                fillColor: '#cccccc',
                style: 'subheader',
                alignment: 'center',
                border: true
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            },
            totalesTabla: {
                fontSize: 8,
                bold: true,
                italics: false,
                fillColor: '#cccccc',
            },
            clienteTabla: {
                fontSize: 10,
                bold: true,
                italics: false,
                fillColor: '#ecfdfe',
            }
        },
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
    }
    return dd;
};



export default reportedeCuentasPorCobrarArupado;
